import React, { Component } from 'react';
import { Form, Button, Modal, Icon } from 'semantic-ui-react';
import Select from "antd/es/select";
import { connect } from 'react-redux';
import './styles.scss';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import 'antd/es/time-picker/style/index.css';
import moment from 'moment';
import {
    DateInput
} from 'semantic-ui-calendar-react';
import {
    getApproval,
    clearSuccessCode
} from '../../core/actions/workingHourAction';
import _ from 'lodash';
class ApproveModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            param: {
                dateFrom: "",
                dateTo: "",
                approverId: ''
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            errorCode: "",
            btnDisable: false
        }
        
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.workingHourReducer.successCode) {
            this.props.clearSuccessCode();
            this.props.handleClose();
        }

        if (nextProps.workingHourReducer.errorCode) {
            
            this.setState({
                errorCode: nextProps.workingHourReducer.errorCode
            });
            this.setState({ btnDisable: false });
            setTimeout(
                function () {
                    this.setState({ errorCode: "" });
                    nextProps.workingHourReducer.errorCode = "";
                }.bind(this),
                2000
            );
        }
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    // Cancel popup
    handleCancel = (evt) => {
        this.props.handleCancel();
    }

    changeDate = (event, { name, value }) => {
        this.setState(prevState => ({
            param: {
                ...prevState.param,
                [name]: value
            },
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.formError,
                    [name]: ''
                }
            }
        }));       
    }

    onChangeApprover = (value ) => {
        this.changeAutoComplete({_name: "approverId", _value: value});
    }

    // Handle on change autoComplete
    changeAutoComplete = evt => {
        const name = evt._name;
        const value = evt._value;
        this.setState(prevState => ({
            param: {
                ...prevState.param,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ""
                }
            }
        }));
    }

    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        (this.state.param.dateFrom === '') ? _formError['dateFrom'] = 'message.600' : _formError['dateFrom'] = '';
        (this.state.param.dateTo === '') ? _formError['dateTo'] = 'message.601' : _formError['dateTo'] = '';
        (this.state.param.approverId === '') ? _formError['approverId'] = 'message.409' : _formError['approverId'] = '';
        

        let dateFrom = new Date(moment(this.state.param.dateFrom, 'DDMMYYYY').format('YYYY-MM-DD'));
        let dateTo = new Date(moment(this.state.param.dateTo, 'DDMMYYYY').format('YYYY-MM-DD'));
        let differentTime = dateTo.getTime() - dateFrom.getTime();
        (differentTime < 0) ? _formError['dateFromTo'] = 'message.040' : _formError['dateFromTo'] = '';

        if (this.state.param.dateFrom !== '' && this.state.param.dateTo !== '' && this.state.param.approverId !== '' && differentTime >= 0) {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }

        return isValidate;
        
    }

    getApprove = () => {
        if (!this.checkValidate()) return;
        
        return this.props.getApproval({ 
            employeeId: this.props.employeeId,
            date: '',
            dateFrom: moment(this.state.param.dateFrom, 'DDMMYYYY').format('YYYY-MM-DD'),
            dateTo: moment(this.state.param.dateTo, 'DDMMYYYY').format('YYYY-MM-DD'),
            approverId: this.state.param.approverId
        });
    }

    render() {
        const { t, size, open, data, initialDate, approverList } = this.props;
        const { param, errorCode } = this.state;
        const _dataApprover = _.map(approverList, (state, index) => ({
            key: "employee-" + index,
            text: state['employeeName'],
            value: state['id'],
        }));
        const { Option } = Select;
        return (
            <div>
                <Modal size={size} open={open} onClose={this.handleCancel}>
                    <Modal.Header className="modal-header">
                        <p>{t("button.getApproval")}</p>
                        <p className="modal-close" onClick={() => this.handleCancel()}>x</p>
                    </Modal.Header>
                    <Modal.Content>
                        <Form className="approve-form">
                            <Form.Group inline className="form-required">
                                <label  className="date-label">{t('labels.approver')}</label>
                                <Select
                                    name="approverId"
                                    onChange={this.onChangeApprover}
                                    style={{ width: '100%', maxWidth: '308px' }}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {(_dataApprover)
                                        ? _dataApprover.map((item, index)=> 
                                            <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                                        )
                                        : ''
                                    }
                                </Select>
                            </Form.Group>
                            <div className="error-message field-error">{t(this.state.inputSubmit.formError['approverId'])}</div>
                            <Form.Group inline className="form-required">
                                <label className="date-label">{t("labels.dateFrom")}</label>
                                <DateInput
                                    name="dateFrom"
                                    clearable
                                    placeholder="DD-MM-YYYY"
                                    iconPosition="right"
                                    animation="none"
                                    dateFormat="DD-MM-YYYY"
                                    initialDate={initialDate}
                                    value={param.dateFrom}
                                    onChange={this.changeDate}
                                    closeOnMouseLeave={false}
                                    localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                                    hideMobileKeyboard={true}
                                    autoComplete="off"
                                    maxLength="0"
                                    closable={true}
                                    onKeyDown={this.handleKeyDown}
                                    className="date-input-from"
                                />
                            </Form.Group>
                            <div className="error-message field-error">{t(this.state.inputSubmit.formError['dateFrom'])}</div>
                            <div className="error-message field-error">{t(this.state.inputSubmit.formError['dateFromTo'])}</div>
                            <Form.Group inline className="form-required">
                                <label className="date-label">{t("labels.dateTo")}</label>
                                <DateInput
                                    name="dateTo"
                                    clearable
                                    placeholder="DD-MM-YYYY"
                                    iconPosition="right"
                                    animation="none"
                                    dateFormat="DD-MM-YYYY"
                                    initialDate={initialDate}
                                    value={param.dateTo}
                                    onChange={this.changeDate}
                                    closeOnMouseLeave={false}
                                    localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                                    hideMobileKeyboard={true}
                                    autoComplete="off"
                                    maxLength="0"
                                    closable={true}
                                    onKeyDown={this.handleKeyDown}
                                    className="date-input-from"
                                />
                            </Form.Group>
                            <div className="error-message field-error">{t(this.state.inputSubmit.formError['dateTo'])}</div>
                            {errorCode ? (
                                <div className="error-message">
                                    {t("message." + errorCode)}
                                </div>
                            ) : (
                                    ""
                                )}
                        </Form>
                        <div className="modal-group-button approve-group">
                            <Button
                                primary
                                onClick={() => this.getApprove()}
                                disabled={this.state.btnDisable}
                            >
                                <Icon name='send' />{t('button.getApproval')}
                            </Button>
                            <Button
                                primary
                                onClick={() => this.handleCancel()}
                            >
                                <Icon name='cancel' />{t('button.cancel')}
                            </Button>
                        </div>
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    getApproval: (opt) => dispatch(getApproval(opt)),
    clearSuccessCode: () => dispatch(clearSuccessCode())
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ApproveModal);
